import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, ReplaySubject, throwError } from 'rxjs';
import { catchError, finalize, switchMap, takeUntil } from 'rxjs/operators';


import { AdministrationsApiService } from 'projects/workspace/src/app/administration/services/administrations-api.service';
import { ToasterService } from '../../../ui-components/toaster';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StripePaymentService } from 'projects/workspace/src/app/shared/services';


@Component({
  selector: 'rnpl-cancel-subscription-modal',
  templateUrl: './cancel-subscription-modal.component.html',
})
export class CancelSubscriptionModalComponent implements OnDestroy {

  public form: FormGroup = this.fb.group({
    password: ['', [Validators.required]],
  });
  public passErrorText: string = null;

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(
    public dialogRef: MatDialogRef<CancelSubscriptionModalComponent>,
    public fb: FormBuilder,
    public toasterService: ToasterService,
    public stripePaymentService: StripePaymentService,
    public administrationsApiService: AdministrationsApiService,
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });
  }

  public submit(): void {
    if (this.submitRequest$.getValue()) { return; }

    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();

    if (this.form.invalid) { return; }

    this.submitRequest$.next(true);

    this.stripePaymentService.cancelSubscription(this.passwordControl.value)
      .pipe(
        switchMap(() => this.administrationsApiService.getCompanyProfile()),
        finalize(() => this.submitRequest$.next(false)),
        catchError((error: HttpErrorResponse) => {
          const errorsList: string[] = error.error.errors;
          const passError = error.error.messages.find(err => err.name === 'password');
          if (passError) {
            this.passwordControl.setErrors({ passwordNotCorrect: true });
            this.passErrorText = passError.message;
            errorsList.splice(passError.message);
          }
          this.toasterService.notify({type: 'error', message: errorsList});
          return throwError(error);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(res => this.dialogRef.close(res));
  }

  get passwordControl(): FormControl { return this.form.get('password') as FormControl; }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
